/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle */
import {createAction, createReducer} from '@reduxjs/toolkit';

const initialState = {
    checkout: {
        isLoading: false,
    },
    completeOrder: {
        order_id: '',
    },
    deliveryStep: {
        shippingAddress: {
            email: {value: ''},
            firstName: {value: ''},
            lastName: {value: ''},
        },
    },
    status: {
        deliveryStep: {loaded: false},
        paymentStep: {loaded: false},
        reviewStep: {loaded: false},
    },
};
export type CheckoutSideReviewType = typeof initialState;

export const setCheckoutSideReview = createAction<CheckoutSideReviewType>(
    'CHECKOUT@SET_CHECKOUT_SIDE_REVIEW',
);

/**
 * Reducer for checkoutSideReview
 * @param {CheckoutSideReviewType} state - reducer state
 * @return {CheckoutSideReviewType} new reducer state
 */
export const _checkoutSideReview = createReducer<CheckoutSideReviewType>(initialState, builder => {
    builder.addCase(setCheckoutSideReview, (state, action) => action.payload);
});
